import Vue from 'vue'

export function callApi ({ name, data: data_ = {}, config: config_ = {} } = {}, data = {}, config = {}) {
  // two mode to parse arguments
  if (typeof arguments[0] == 'object') {
    // console.debug("options mode")
    data = data_
    config = config_
  } else {
    // console.debug("arguments mode")
    name = arguments[0];
  }
  return new Promise((resolve, reject) => {
    let { method = "post", mask = false } = config || {};
    method = method.toLowerCase();
    if (method == 'get') {
      var reqData = { params: { name, data } };
    } else {
      var reqData = { name, data };
    }
    let loading = null
    if (mask) {
      loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    }
    Vue.http[method]("https://fc-mp-58fb5d82-8f42-428b-93b5-287a4376525b.next.bspapp.com/admin_api", reqData).then(res => {
      console.debug(`callApi ${name}`, res, `status:${res.data.status}`, "data:", res.data.data)
      if ( res.data.status == undefined || res.data.status < 0 || res.data.status > 100  ) {
        var err = new Error(res.data.message);
        reject(err)
      } else {
        resolve(res.data);
      }
      loading && loading.close();
    }).catch(e => {
      loading && loading.close();
      console.error(e);
      reject(e);
    })
  })
}

export function api ({ name, config: config_ }, config = {}) {
  if (typeof arguments[0] == 'object') {
    // console.debug("options mode")
    config = config_;
  } else {
    // console.debug("arguments mode")
    name = arguments[0];
  }
  return (data) => {
    return callApi({ name, data, config })
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js